import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { SubBar, MainView, Form, FormControl, FormMessage, Button, AppSettings, HintView, Grid } from "lib/index";
import { stateSelector, initializeView, updateModel, submit } from "./index";
import Hint from "./UserAccountHint";

@connect(
  (state) => ({
    model: stateSelector(state).form.model,
    dirty: stateSelector(state).form.dirty,
    valid: stateSelector(state).form.valid,
    errors: stateSelector(state).form.errors,
    submitLoading: stateSelector(state).form.submitLoading,
    submitFailed: stateSelector(state).form.submitFailed,
  }),
  (dispatch) =>
    bindActionCreators(
      {
        initializeView,
        updateModel,
        submit,
      },
      dispatch
    )
)
export default class UserAccountView extends React.PureComponent {
  componentDidMount() {
    this.props.initializeView();
  }

  handleSubmit(event) {
    event.preventDefault();
    this.props.submit();
  }

  handleModelPropChange(prop, value) {
    const { model, updateModel } = this.props;
    updateModel({
      ...model,
      [prop]: value,
    });
  }

  render() {
    const { model, valid, dirty, submitLoading, errors } = this.props;
    return (
      model && (
        <MainView.Container>
          <SubBar hasSidebar>
            <div className="pull-left">
              <h1>{I18n.t("papp.settings.UserAccountView.title")}</h1>
            </div>
            <div className="pull-right">
              <Button
                primary
                as="a"
                onClick={this.handleSubmit.bind(this)}
                disabled={!valid || !dirty || submitLoading}
                content={I18n.t("papp.common.save_changes")}
              />
            </div>
          </SubBar>

          <MainView.Content hasSubBar padded={false}>
            <HintView.Container>
              <HintView.Content>
                <Form className="text" onSubmit={this.handleSubmit.bind(this)} error={!valid} loading={submitLoading}>
                  {errors.base && <FormMessage error={errors.base} />}

                  <FormControl.InputFormGroup
                    {...FormControl.addProps(`model.full_name`, { errors })}
                    value={model.full_name}
                    onChange={this.handleModelPropChange.bind(this, "full_name")}
                    label={I18n.humanAttributeName("admin_user", "full_name")}
                    required
                  />

                  <FormControl.InputFormGroup
                    {...FormControl.addProps(`model.email`, { errors })}
                    value={model.email}
                    onChange={this.handleModelPropChange.bind(this, "email")}
                    label={I18n.humanAttributeName("admin_user", "email")}
                    required
                    type="email"
                  />

                  <div className="ui section">
                    <h3>{I18n.t("papp.settings.UserAccountView.site_settings_title")}</h3>
                    <Grid columns={2}>
                      <Grid.Column>
                        <FormControl.LocaleSelectFormGroup
                          {...FormControl.addProps(`model.locale`, { errors })}
                          value={model.locale}
                          onChange={this.handleModelPropChange.bind(this, "locale")}
                          label={I18n.humanAttributeName("admin_user", "locale")}
                          locales="admin_user_locales"
                        />
                      </Grid.Column>
                      <Grid.Column>
                        <FormControl.SelectFormGroup
                          {...FormControl.addProps(`model.time_zone_name`, { errors })}
                          value={model.time_zone_name}
                          onChange={this.handleModelPropChange.bind(this, "time_zone_name")}
                          label={I18n.humanAttributeName("admin_user", "time_zone_name")}
                          options={AppSettings.time_zones}
                        />
                      </Grid.Column>
                    </Grid>
                  </div>

                  <div className="ui section">
                    <h3>{I18n.t("papp.settings.UserAccountView.password_change_title")}</h3>

                    <FormControl.InputFormGroup
                      {...FormControl.addProps(`model.current_password`, { errors })}
                      value={model.current_password}
                      onChange={this.handleModelPropChange.bind(this, "current_password")}
                      label={I18n.humanAttributeName("admin_user", "current_password")}
                      type="password"
                    />

                    <FormControl.InputFormGroup
                      {...FormControl.addProps(`model.password`, { errors })}
                      value={model.password}
                      onChange={this.handleModelPropChange.bind(this, "password")}
                      label={I18n.humanAttributeName("admin_user", "password")}
                      type="password"
                    />

                    <FormControl.InputFormGroup
                      {...FormControl.addProps(`model.password_confirmation`, { errors })}
                      value={model.password_confirmation}
                      onChange={this.handleModelPropChange.bind(this, "password_confirmation")}
                      label={I18n.humanAttributeName("admin_user", "password_confirmation")}
                      type="password"
                    />
                  </div>

                  <button type="submit" hidden />
                </Form>
              </HintView.Content>
              <HintView.Sidebar>
                <Hint />
              </HintView.Sidebar>
            </HintView.Container>
          </MainView.Content>
        </MainView.Container>
      )
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/settings/UserAccountView/UserAccountView.jsx